import { User } from './user';

export class AnonymousUser implements User {
  kind: 'anonymous';
  fullName = undefined;
  guid = undefined;
  isAnonymous = true;
  profile = undefined;
  scopes = [];

  constructor(public accessToken: string) {}
}
